type IdentifierFn<T> = (item: T) => string;

export const checkForDuplicates = <T>(
  list: T[],
  getIdentifier: IdentifierFn<T>,
): { item: T | null; hasDuplicate: boolean } => {
  const seen = new Set<string>();
  for (const item of list) {
    const identifier = getIdentifier(item);
    if (seen.has(identifier)) {
      return { item, hasDuplicate: true };
    }
    seen.add(identifier);
  }
  return { item: null, hasDuplicate: false };
};
